import { Spin, StyledLoader } from "./index.styled";

export const Loader = () => (
  <StyledLoader>
    <Spin />
  </StyledLoader>
);
